import styled from 'styled-components';

export const Container = styled.div`
  user-select: none;
  word-break: keep-all;
`;

export const HeroTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const ColBox = styled.div<{ $gap?: number; $center?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap && `${$gap}px`};
  align-items: ${({ $center }) => $center && 'center'};
`;

export const BadgeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

export const MembershipBadge = styled.div`
  padding: 2px;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;

  span {
    padding: 2px 8px;
    color: #fff;
    text-align: center;
    font-family: Paperlogy;
    font-size: 14px;
    font-weight: 700;
    line-height: 145%; /* 20.3px */
  }
`;

export const MembershipBadgeFree = styled(MembershipBadge)`
  background: linear-gradient(94.45deg, #e0e1e6 0%, #bdc1c7 100%);

  span {
    background: linear-gradient(106deg, #c4c6cc 0%, #85898e 100%);
  }
`;

export const MembershipBadgeStandard = styled(MembershipBadge)`
  background: linear-gradient(94.45deg, #3cb5de 0%, #aad545 100%);

  span {
    background: linear-gradient(106deg, #00a2e7 0%, #94bf08 100%);
  }
`;

export const MembershipBadgePremium = styled(MembershipBadge)`
  background: linear-gradient(94.45deg, #3f9bff 0%, #7c29fb 100%);
  span {
    background: linear-gradient(106deg, #008aff 0%, #6900f3 100%);
  }
`;

export const Section = styled.div<{ $background?: string }>`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  background: ${({ $background }) => ($background ? $background : '#FFF')};
`;

interface SectionContainerProp {
  $isrow?: boolean;
  $gap?: number;
  $space?: boolean;
}

export const SectionTitle = styled.div<{ $color?: string; $center?: boolean }>`
  text-align: ${({ $center }) => $center && 'center'};
  color: ${({ $color }) => $color ?? '#222'};
  font-size: 20px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.4px;
  white-space: pre-line;
`;

export const SectionDescription = styled.div<{ $color?: string }>`
  color: ${({ $color }) => $color ?? '#222'};
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

export const UsingGuideSectionTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

export const UsingGuideSectionDescription = styled.div`
  color: #616161;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

export const UsingGuide = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  gap: 40px;
  align-self: stretch;
  flex-wrap: wrap;
  align-items: stretch;
`;

export const UsingGuideTitle = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.4px;
`;

export const UsingGuideDesc = styled.div`
  color: #616161;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

export const ImgSection = styled.div<{ $bg?: string }>`
  display: flex;
  padding: 40px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: url('/assets/images/guide-landing/cta_bg_pc.png') no-repeat
    center/cover;
  background-color: ${({ $bg }) => $bg ?? ''};
`;

export const CtaTitle = styled.div`
  color: #fff;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.48px;
`;

export const CtaButton = styled.button`
  cursor: pointer;
  border: none;
  outline: none;
  display: flex;
  padding: 8px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 30px;
  background: #fff;

  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;
